// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__Rqbvu","emailButtons":"Contact_emailButtons__3Du9w","additionalEmails":"Contact_additionalEmails__sFYHr"};